/**
 * Copyright (c) 2026, WSO2 LLC. (https://www.wso2.com).
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import {EmbeddedFlowComponentV2 as EmbeddedFlowComponent, FlowMetadataResponse} from '@asgardeo/browser';
import {Context, createContext, ReactElement} from 'react';

export interface ComponentRenderContext {
  additionalData?: Record<string, any>;
  authType: 'signin' | 'signup' | 'recovery';
  formErrors: Record<string, string>;
  formValues: Record<string, string>;
  isFormValid: boolean;
  isLoading: boolean;
  meta?: FlowMetadataResponse | null;
  onInputBlur?: (name: string) => void;
  onInputChange: (name: string, value: string) => void;
  onSubmit?: (component: EmbeddedFlowComponent, data?: Record<string, any>, skipValidation?: boolean) => void;
  touchedFields: Record<string, boolean>;
}

export type ComponentRenderer = (
  component: EmbeddedFlowComponent,
  context: ComponentRenderContext,
) => ReactElement | null;

export type ComponentRendererMap = Record<string, ComponentRenderer>;

const ComponentRendererContext: Context<ComponentRendererMap> = createContext<ComponentRendererMap>({});

export default ComponentRendererContext;
